<template>
  <div class="tags-group" :class="show ? 'show-tags' : ''">
    <ul class="tags-list">
      <li
        class="tag-item"
        v-for="(tag, index) in getSortedTags"
        :key="`tag-item-${index}`"
        :class="index >= maxLimit ? 'in-visible' : ''"
      >
        <LimitedText :text="tag" :maxLength="25" />
      </li>
      <li class="tags-count" @click="toggleTags" v-if="getRemainingCount > 0">
        <span class="count" dir="ltr">{{ getRemainingCount }}+</span>
        <FIcon name="menu-arrow" class="close" size="0.8rem" />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "TagsGroup",
  props: {
    tags: {
      type: Array,
      default: [],
    },

    maxLimit: {
      type: Number,
      default: 2,
    },
  },

  data() {
    return {
      show: false,
    };
  },

  computed: {
    /**
     * Handle un visible tags count
     * @return {Number}
     */
    getRemainingCount() {
      return this.tags.length - this.maxLimit;
    },

    /**
     * Handle the sorted tags
     * @return {Array}
     */
    getSortedTags() {
      return this.tags.sort(function (a, b) {
        return a.length - b.length;
      });
    },
  },

  methods: {
    /**
     * Handle toggle show tags
     * @return {Boolean}
     */
    toggleTags() {
      this.show = !this.show;
    },
  },
};
</script>

<style lang="scss" src="./styles.scss" scoped />
